/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";
import TableTemplate from "./Table";
import CardLayout from "../Cards/CardLayout";
import { FiMoreVertical } from "react-icons/fi";
import { useFetchData } from "../../customHooks/useGetDashboardData";
import { IDevice } from "../../utils/interfaces";
import CardError from "../feedBacks/CardError";
import Loader from "../feedBacks/loader";
import NoContent from "../feedBacks/NoContent";
import AddDeviceModal from "../Modals/AddDeviceModal";
import { IconWrapper } from "../../customHooks/useIcon";
import { ROWS_PER_PAGE } from "../../utils/constants";

const columns = [
  "Device Name",
  // "Company",
  "Zone",
  "Asset Type",
  "Asset Capacity",
  // "Time/Date",
];

const DevicesTable = ({ company_id }: { company_id?: string }) => {
  const [page, setPage] = React.useState(1);

  const { data, isLoading, error, refetch }: any = useFetchData(
    ["/devices", "fetchAllDevices", company_id, page], // Include page in key so it updates when page changes
    "/devices",
    {
      page,
      page_size: ROWS_PER_PAGE,
      company_id,
    },
    // @ts-ignore
    {}
  );

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    refetch();
  };

  const tableData =
    data?.results.map((item: IDevice) => ({
      "Device Name": item.asset_name,
      // Company: item.company.name,
      Zone: item?.zone?.name || "N/A",
      "Asset Type": item?.asset_type || "N/A",
      "Asset Capacity": item?.asset_capacity || 0,
      // "Time/Date": formatDateForDisplay(item.created_at),
      ...item,
    })) ?? [];

  const [editDeviceModal, setEditDeviceModal] = React.useState(false);
  const [selectedDevice, setSelectedDevice] = React.useState<IDevice | null>(
    null
  );

  return (
    <CardLayout title="" className="lg:min-w-[550px] flex-1">
      {isLoading ? (
        <div className="flex justify-center items-center h-full w-full">
          <Loader />
        </div>
      ) : error ? (
        <CardError message="Error fetching devices" />
      ) : !tableData || tableData.length === 0 ? (
        <NoContent message="No devices found" />
      ) : (
        <TableTemplate
          data={tableData}
          columns={columns}
          extraAction={true}
          extraActionIcon={<IconWrapper icon={FiMoreVertical} />}
          actionType="showPopUp"
          extraActionPopUpContent={(row) => (
            <>
              <span className="w-full flex items-center justify-center cursor-pointer hover:bg-primary-blackLighter2 hover:rounded-full hover:px-4 hover:py-1">
                Delete
              </span>
              <span
                onClick={() => {
                  setEditDeviceModal(true);
                  setSelectedDevice(row);
                }}
                className="w-full flex items-center justify-center cursor-pointer hover:bg-primary-blackLighter2 hover:rounded-full hover:px-4 hover:py-1"
              >
                Modify
              </span>
            </>
          )}
          totalCount={data?.total_results || 0}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={ROWS_PER_PAGE}
        />
      )}

      <AddDeviceModal
        isModalOpen={editDeviceModal}
        closeModal={() => setEditDeviceModal(false)}
        enableOutsideClick={false}
        type="edit"
        data={selectedDevice as IDevice}
      />
    </CardLayout>
  );
};

export default DevicesTable;
